import React from "react";
import { useState } from "react";
import { Button, Row, Col, Space, List } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import { getChildrenToRender } from "@/utils";
import "./less/process.less";
import { useTranslation } from 'react-i18next';

const customerData = [
  {
    year: 2017,
    customer: [
      {
        name: 'about.2017Milestones01',
      },
      {
        name: 'about.2017Milestones02',
      },
      {
        name: 'about.2017Milestones03',
      },
      {
        name: 'about.2017Milestones04'
      },
      {
        name: 'about.2017Milestones05'
      }
    ]
  },
  {
    year: 2018,
    customer: [
      {
        name: 'about.2018Milestones01',
      },
      {
        name: 'about.2018Milestones02',
      },
      {
        name: 'about.2018Milestones03',
      },
    ]
  },
  {
    year: 2019,
    customer: [
      {
        name: 'about.2019Milestones01',
      },
      {
        name: 'about.2019Milestones02',
      },
      {
        name: 'about.2019Milestones03',
      },
      {
        name: 'about.2019Milestones04',
      },
    ]
  },
  {
    year: 2020,
    customer: [
      {
        name: 'about.2020Milestones01',
      },
      {
        name: 'about.2020Milestones02',
      },
      {
        name: 'about.2020Milestones03',
      },
      {
        name: 'about.2020Milestones04',
      },
    ]
  },
  {
    year: 2021,
    customer: [
      {
        name: 'about.2021Milestones01',
      },
      {
        name: 'about.2021Milestones02',
      },
    ]
  },
  {
    year: 2022,
    customer: [
      {
        name: 'about.2022Milestones01',
      },
      {
        name: 'about.2022Milestones02',
      },
    ]
  },
  {
    year: 2023,
    customer: [
      {
        name: 'about.2023Milestones01',
      },
      {
        name: 'about.2023Milestones02',
      },
      {
        name: 'about.2023Milestones03',
      },
    ]
  },
  {
    year: 2024,
    customer: [
      {
        name: 'about.2024Milestones01',
      },
      {
        name: 'about.2024Milestones02',
      }
    ]
  }
];

const processYear = customerData.map((item) => item.year);

function Content9(props) {
  const { dataSource, ...restProps } = props;
  const [year, setYear] = useState(2017);
  const [percent, setPercent] = useState(12.5);
  const [yearList, setYearList] = useState(processYear.slice(0, 6));
  const {t} = useTranslation()
  const increase = () => {
    setPercent((prevPercent) => {
      const newPercent = prevPercent + 12.5;
      if (newPercent > 75) {
        return 75;
      }
      return newPercent;
    });
    setYear((prevYear) => {
      const newYear = prevYear + 1;
      if (newYear > 2024) {
        return 2024;
      }

      if (newYear > yearList[5]) {

        const index = processYear.indexOf(newYear);

        setYearList(processYear.slice(index - 5, index + 1));

      }
      return newYear;
    });
  };

  const decline = () => {
    setPercent((prevPercent) => {
      const newPercent = prevPercent - 12.5;
      if (newPercent < 12.5) {
        return 12.5;
      }
      return newPercent;
    });
    setYear((prevYear) => {
      const newYear = prevYear - 1;
      if (newYear >= 2017 && newYear < yearList[0]) {
        const index = processYear.indexOf(newYear);

        setYearList(processYear.slice(index, index + 6));
      }
      if (newYear < 2017) {
        return 2017;
      }
      return newYear;
    });
  };

  // const children = dataSource.block.children.map(getBlockChildren);
  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <div {...dataSource.titleWrapper}>
          <Button
            className="content-btn-left"
            onClick={decline}
            shape="circle"
            icon={<ArrowLeftOutlined />}
            ghost
          />

          {dataSource.titleWrapper.children.map((val,i)=>getChildrenToRender(val,i,t))}
          <Button
            className="content-btn-right"
            onClick={increase}
            shape="circle"
            icon={<ArrowRightOutlined />}
            ghost
          />
        </div>
        <div className="content">
          <Row>
            <Col span={8}>
              <div className="content-year">{year}</div>
            </Col>
            <Col span={14} offset={2}>
              <List
                grid={{ gutter: [16, 28], column: 1 }}
                dataSource={customerData[year - 2017].customer}
                renderItem={(item) => (
                  <>
                    <div className="content-customer">{t(item.name)}</div>
                    {/* <span className="content-project">{item.project}</span> */}
                  </>
                )}
              />
            </Col>
          </Row>
        </div>
      </div>
      <div className="container">
        <div className="path" />
        <div className="progress">
          <div
            className="progress-bar"
            style={{
              width: `${percent}%`,
              background: "linear-gradient(270deg, #0070E2 0%, #003D7C 100%)",
            }}
          >
            <span />
          </div>
        </div>
        <div className="path" />
      </div>
      <div>
        <Row>
          {
            yearList.map((item, index) => (
              <Col offset={index === 0 ? 3 : 0} span={3} key={item + index}>
                <span className="year">{item}</span>
              </Col>
            ))
          }
        </Row>
      </div>
    </div>
  );
}

export default Content9;
